import { AxiosErrorHandler, Loading } from 'ui';
import { KudoContentObjectBody } from '../content-object-renderer';
import { usePublicKudoQuery } from '../queries';

type P = {
  id: string;
};

const PublicKudos = ({ id }: P) => {
  const { data: kudoContentObject, error, isPending } = usePublicKudoQuery(id);

  if (isPending) {
    return <Loading />;
  }

  return (
    <AxiosErrorHandler error={error}>
      {kudoContentObject ? <KudoContentObjectBody item={kudoContentObject} /> : null}
    </AxiosErrorHandler>
  );
};

export default PublicKudos;
